<div class="manutencao-view">
  <div class="message">
    <img src="assets/img/logo-next-header.svg" />
    <h2>Em manutenção</h2>
  </div>
</div>
